module.exports = __webpack_public_path__ + "images/emoji/crescent_moon.4fd9e78608e6e46f3585.png";